<div class="onhover-dropdown mobile-account" [class.active]="isOpen" (click)="toggleMenu()">
  @if (customer) {
    <span class="account-avatar">{{ name | slice:0:1 }}</span>
  } @else {
    <span class="material-icons icon-header" aria-hidden="true">person</span>
  }
  <span class="account-name">{{ name }}</span>
  <ul class="onhover-show-div">
    @if (!customer) {
      <li>
        <a [routerLink]="'/pages/login'" data-lng="en">
          {{ 'login' | translate }}
        </a>
      </li>
    }
    @if (customer) {
      <li>
        <a [routerLink]="'/pages/mi-perfil'" data-lng="en">
          {{ 'miperfil' | translate }}
        </a>
      </li>
    }
    @if (customer) {
      <li>
        <a [routerLink]="'/pages/updatedPriceList'" data-lng="en">
          {{ 'actualizacion-precios' | translate }}
        </a>
      </li>
    }
    @if (customer) {
      <li>
        <a (click)="logout()" data-lng="es">
          {{ 'logout' | translate }}
        </a>
      </li>
    }
  </ul>
</div>
